<template>
  <div class="gc-cost-wrap">
    <van-nav-bar :border="false"
                 title="成本信息"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="tab-title" v-if="canDepCost">
      <div class="item" :class="{'active':status==0}" @click="handleUserCost">个人成本</div>
      <div class="item" :class="{'active':status==1}" @click="handleDepCost">部门成本</div>
      <!-- <div class="item" :class="{'active':status==2}" @click="handleComCost">公司成本</div> -->
    </div>
    <div class="cost-box-wrap" v-for="(item,index) in costList" :key="index">
      <div class="title">{{ item.Item.Name }}成本<span>{{ item.AcMoney }}</span></div>
      <div class="item" v-for="(item2,index2) in item.ItemList" :key="index2">
        <div class="info-wrap">
          <span class="t">{{ item2.Item.Name }}</span>
          <span>{{ item2.AcMoney }}</span>
        </div>
        <div class="remarks" v-if="item2.AcRemark">{{ item2.AcRemark }}</div>
      </div>
    </div>
    <!-- <div class="cost-box-wrap">
        <div class="title">分摊成本</div>
            <div class="item">
            <div class="info-wrap">
                <span class="t"> 办公场地</span>
                <span>8967</span>
            </div>
        </div>
        <div class="item">
            <div class="info-wrap">
                <span class="t"> 招聘费</span>
                <span>8967</span>
            </div>
        </div>
        <div class="item">
            <div class="info-wrap">
                <span class="t"> 折旧费</span>
                <span>8967</span>
            </div>
        </div>
        <div class="item">
            <div class="info-wrap">
                <span class="t"> 其他</span>
                <span>8967</span>
            </div>
        </div>
        <div class="item">
            <div class="info-wrap">
                <span class="t"> 手续费</span>
                <span>8967</span>
            </div>
        </div>
    </div>
    <div class="cost-box-wrap">
        <div class="title">浮动成本</div>
        <div class="item">
            <div class="info-wrap">
                <span class="t">内部支出</span>
                <span>8967</span>
            </div>
            <div class="remarks">【个税申报工作】支出</div>
        </div>
        <div class="item">
            <div class="info-wrap">
                <span class="t">内部支出</span>
                <span>8967</span>
            </div>
            <div class="remarks">【个税申报工作】支出</div>
        </div>
    </div> -->
    <div class="cost-bottom-wrap">
      成本合计：<span>{{ allMoney }}元</span>
    </div>
  </div>
</template>

<script>
import { hasPerm } from '@/utils/perm';

export default {
  data() {
    return {
      costList: [],
      allMoney: 0,
      status: this.$route.query.status ? this.$route.query.status : 0,
      depList: [],
      depAllMoney: 0,
    }
  },
  computed: {
    // 部门/公司成本属他人敏感数据（≈薪酬级），按 RBAC 权限展示，不再依赖 legacy isDep 标志
    canDepCost() {
      return hasPerm('analytics.team.read');
    },
    canComCost() {
      return hasPerm('analytics.tenant.read');
    },
  },
  mounted() {
    // URL 参数降级：无对应报表权限时强制回落个人成本，防止 ?status=1/2 越权
    if (this.status == 1 && !this.canDepCost) {
      this.status = 0;
    } else if (this.status == 2 && !this.canComCost) {
      this.status = 0;
    }
    if (this.status == 1) {
      this.WebGetDepUserAcMoneyInfoLst()
    } else if (this.status == 2) {
      this.WebGetComUserAcMoneyInfoLst();
    } else {
      this.WebGetUserAcMoneyInfoLst()
    }

  },
  methods: {
    // 个人成本详情
    WebGetUserAcMoneyInfoLst() {
      let data = {
        UserSysno: localStorage.getItem('UserSysno'),
        StartDate: this.$route.query.date || '',
        EndDate: this.$route.query.date || ''
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetUserAcMoneyInfoLst', data, res => {
        console.log(res);
        res = res.WebGetUserAcMoneyInfoLstResult
        if (res.ResponseCode == 1) {
          this.costList = res.ItemLst;
          this.allMoney = res.ResponseMessage
        }
      }, err => {
      })
    },
    // 部门成本详情
    WebGetDepUserAcMoneyInfoLst() {
      let data = {
        DepSysno: localStorage.getItem('GovDepSysno'),
        StartDate: this.$route.query.date || '',
        EndDate: this.$route.query.date || ''
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetDepUserAcMoneyInfoLst', data, res => {
        console.log(res);
        res = res.WebGetDepUserAcMoneyInfoLstResult
        if (res.ResponseCode == 1) {
          this.costList = res.ItemLst;
          this.allMoney = res.ResponseMessage
        }
      }, err => {
      })
    },
    // 公司成本详情
    WebGetComUserAcMoneyInfoLst() {
      let data = {
        ComSysno: localStorage.getItem('UserComSysno'),
        StartDate: this.$route.query.date || '',
        EndDate: this.$route.query.date || ''
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetComUserAcMoneyInfoLst', data, res => {
        console.log(res);
        res = res.WebGetComUserAcMoneyInfoLstResult
        if (res.ResponseCode == 1) {
          this.costList = res.ItemLst;
          this.allMoney = res.ResponseMessage
        }
      }, err => {
      })
    },
    handleUserCost() {
      this.status = 0
      this.WebGetUserAcMoneyInfoLst()
    },
    handleDepCost() {
      this.status = 1
      this.WebGetDepUserAcMoneyInfoLst();
    },
    handleComCost() {
      this.status = 2
      this.WebGetComUserAcMoneyInfoLst();
    }
  },
}
</script>

<style lang="less" scoped>
.gc-cost-wrap {
  padding-bottom: 1.6rem;
}

.tab-title {
  display: flex;
  justify-content: space-around;
  background: #fff;
  padding: .3rem 0 .2rem;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);

  .item {
    font-size: 0.4rem;
    padding-bottom: 0.15rem;
    color: #333;
    position: relative;

    &.active {
      color: #4c52be;

      &:after {
        position: absolute;
        left: 50%;
        margin-left: -0.64rem;
        bottom: 0;
        content: '';
        width: 1.28rem;
        height: 0.08rem;
        background-color: #4c52be;
        border-radius: 0.03rem;
      }
    }
  }
}

.cost-box-wrap {
  margin: .28rem .28rem 0;
  padding: .5rem .5rem .1rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .title {
    padding-bottom: 0.4rem;
    font-size: 0.47rem;
    font-weight: 700;
    color: #333333;
    display: flex;
    justify-content: space-between;
    // border-bottom: 1px solid #eee;
  }

  .item {
    padding: .4rem .1rem;
    border-top: 1px solid #efefef;
    font-size: 0.37rem;
    color: #333333;

    .info-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .remarks {
      margin-top: 0.25rem;
      padding: .2rem .35rem;
      font-size: 0.33rem;
      color: #888888;
      background-color: #f0f0f0;
      border-radius: 0.13rem;
    }
  }
}

.cost-bottom-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-left: 0.9rem;
  padding-right: 0.9rem;
  height: 1.3rem;
  line-height: 1.3rem;
  background-color: #ffffff;
  font-size: 0.37rem;
  color: #4c52be;
  box-shadow: 0rem 0.01rem 0.13rem 0rem rgba(32, 23, 147, 0.17);
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/my/Cost.vue